import Vue from 'vue'
import io from 'socket.io-client'

import {
  WEB_SOCKET_ONOPEN,
  WEB_SOCKET_ONCLOSE,
  WEB_SOCKET_ONERROR,
  WEB_SOCKET_ONMESSAGE,
  WEB_SOCKET_RECONNECT,
  WEB_SOCKET_RECONNECT_ERROR,
} from '@/lib/mutationTypes'

const state = {
  socket: null,
  isConnected: false,
  message: '',
  reconnectError: false,
}

const socketOptions = {
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  reconnectionAttempts: 5,
}

const mutations = {
  [WEB_SOCKET_ONOPEN](state, socket) {
    state.socket = socket
    state.isConnected = true
  },
  [WEB_SOCKET_ONCLOSE](state) {
    state.socket = null
    state.isConnected = false
  },
  [WEB_SOCKET_ONERROR](state, event) {
    console.error(state, event, 'error')
  },
  [WEB_SOCKET_ONMESSAGE](state, message) {
    state.message = message
  },
  [WEB_SOCKET_RECONNECT](state, count) {
    console.info(state, count, 'info')
  },
  [WEB_SOCKET_RECONNECT_ERROR](state) {
    state.reconnectError = true
  },
}

const actions = {
  connectWebsocket({ commit, state }, url) {
    if (!state.socket) {
      const socket = io(url, socketOptions)

      // ========== connect ========== //
      socket.on('connect', () => {
        commit(WEB_SOCKET_ONOPEN, socket)
      })

      socket.on('connect_error', (error) => {
        commit(WEB_SOCKET_ONERROR, error)
      })

      socket.on('connect_timeout', (timeout) => {
        commit(WEB_SOCKET_ONERROR, timeout)
      })

      // ========== reconnect ========== //
      socket.on('reconnect', () => {
        commit(WEB_SOCKET_ONOPEN, socket)
      })

      socket.on('reconnecting', (attemptNumber) => {
        commit(WEB_SOCKET_RECONNECT, attemptNumber)
      })

      socket.on('reconnect_failed', () => {
        commit(WEB_SOCKET_RECONNECT_ERROR)
      })

      // ========== disconnect ========== //
      socket.on('disconnect', () => {
        commit(WEB_SOCKET_ONCLOSE)
      })

      // ========== event message ========== //
      socket.on('message', (data) => {
        commit(WEB_SOCKET_ONMESSAGE, data)
      })

      socket.on('error', (error) => {
        commit(WEB_SOCKET_ONERROR, error)
      })
    }
  },
  disconnectWebsocket({ state }) {
    state.socket.close()
  },
}

const getters = {
  webSocket: (state) => state.socket,
  webSocketMessage: (state) => state.message,
}

export default {
  state,
  getters,
  mutations,
  actions,
}
